import { serviceName } from '../resources/serviceConstants';
import {
  GENERATE_BEARER_TOKEN,
  GET_ALL_USER_ROLES,
  GET_USER_ROLES,
  RECOGNITIONS_LIST,
} from '../resources/endPoint';

// Generate bearer token for the user
export const generateBearerToken = (mailId) => {
  const data = {
    emailId: mailId,
  };

  return {
    url: GENERATE_BEARER_TOKEN,
    method: 'post',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.USER_ROLES_MS,
  };
};

// Get User Roles - List of modules/tabs & actions allowed for the user
export const getUserRoles = (token, mailId) => {
  return {
    url: GET_USER_ROLES + '?mailId=' + encodeURIComponent(mailId),
    method: 'get',
    headers: { 'content-type': 'application/json', authorization: token },
    authRequired: false,
    csrfToken: true,
    service: serviceName.USER_ROLES_MS,
  };
};

export const getAllRoles = (token) => {
  return {
    url: GET_ALL_USER_ROLES,
    method: 'get',
    headers: { 'content-type': 'application/json', authorization: token },
    authRequired: false,
    csrfToken: true,
    service: serviceName.USER_ROLES_MS,
  };
};

export const updateRole = (id, data, token) => {
  return {
    url: GET_ALL_USER_ROLES + '/' + id,
    method: 'patch',
    headers: { 'content-type': 'application/json', authorization: token },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.USER_ROLES_MS,
  };
};

export const addRecognition = (token, data) => {
  return {
    url: RECOGNITIONS_LIST,
    method: 'post',
    headers: { 'content-type': 'application/json', authorization: token },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.ACHIEVEMENTS_MS,
  };
};

export const deleteRecognition = (token, id) => {
  return {
    url: RECOGNITIONS_LIST + '?recognitionId=' + id,
    method: 'delete',
    headers: { 'content-type': 'application/json', authorization: token },
    authRequired: false,
    csrfToken: true,
    service: serviceName.ACHIEVEMENTS_MS,
  };
};

export const getRecognition = (token, userId) => {
  const url = userId ? `${RECOGNITIONS_LIST}?userId=${userId}` : RECOGNITIONS_LIST;

  return {
    url: url,
    method: 'get',
    headers: { 'content-type': 'application/json', authorization: token },
    authRequired: false,
    csrfToken: true,
    service: serviceName.ACHIEVEMENTS_MS,
  };
};
